import { Layout } from 'react-admin'

import { MyMenu } from '../Menu'
import { MyAppBar } from '../AppBar'

export const MyLayout = (props: any) => <Layout {...props} menu={MyMenu} appBar={MyAppBar} />
